
const database: Record<string, any> = {};

const getFileBasePath = (path: string): string | null => {

  let filePath = path;
  if (filePath.startsWith('/')) filePath = filePath.slice(1);
  if (filePath.endsWith('/')) filePath = filePath.slice(0, -1);

  const parts = filePath.split('/');
  if (parts.length === 1 && database[filePath]) return filePath;

  const basePath = parts[0];
  if (!basePath) return null;
  let workingFile: any;
  if (database[basePath]) workingFile = database[basePath];
  else {
    try {
      workingFile = require(`../../data/${basePath}.json`);
      if (!workingFile) {
        console.error(`Error reading file ${basePath}:`, 'File not found');
        return null;
      }
      database[basePath] = JSON.parse(JSON.stringify(workingFile));
      // seems like default is the accessor when it is an array
      if (database[basePath].default) {
        database[basePath] = { ...database[basePath].default, ...database[basePath] };
        delete database[basePath].default;
      }
    } catch (error) {
      console.error(`Error reading file ${filePath}:`, error);
    }
  }
  return basePath;
}

export const readJsonFile = (path: string): any => {
  const basePath = getFileBasePath(path);
  if (!basePath) return undefined;
  const file = database[basePath];
  let filePath = path;
  if (filePath.startsWith('/')) filePath = filePath.slice(1);
  if (filePath.endsWith('/')) filePath = filePath.slice(0, -1);

  const parts = filePath.split('/');
  if (parts.length === 1) return file;
  let current = file;
  for (let i = 1; i < parts.length; i++) {
    if (!current[parts[i]]) {
      console.error(`unable to find path ${filePath}:`);
      return null;
    }
    current = current[parts[i]];
  }
  return current;
};

export const deleteFilePath = (path: string) => {
  try {
    const basePath = getFileBasePath(path);
    if (!basePath) return;

    let filePath = path;
    if (filePath.startsWith('/')) filePath = filePath.slice(1);
    if (filePath.endsWith('/')) filePath = filePath.slice(0, -1);

    const parts = filePath.split('/');
    if (parts.length === 1) {
      delete database[basePath];
      return;
    }
    let current = database[basePath];
    for (let i = 1; i < parts.length; i++) {
      if (!current[parts[i]]) {
        return;
      }
      if (i + 1 === parts.length) {
        delete current[parts[i]];
        return;
      } else {
        current = current[parts[i]];
      }
    }
  } catch (error) {
    console.error(`Error writing file ${path}:`, error);
  }
}

export const writeJsonFile = (path: string, data: any): void => {
  try {
    const basePath = getFileBasePath(path);
    if (!basePath) return;

    let filePath = path;
    if (filePath.startsWith('/')) filePath = filePath.slice(1);
    if (filePath.endsWith('/')) filePath = filePath.slice(0, -1);

    const parts = filePath.split('/');
    if (parts.length === 1) {
      database[basePath] = data;
      return;
    }
    let current = database[basePath];
    for (let i = 1; i < parts.length; i++) {
      if (!current[parts[i]]) {
        current[parts[i]] = {};
      }
      if (i + 1 === parts.length) {
        if (data && data['.sv'] === 'timestamp') data = new Date();
        current[parts[i]] = data;
      } else {
        current = current[parts[i]];
      }
    }
  } catch (error) {
    console.error(`Error writing file ${path}:`, error);
  }
};